function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useCallback, useRef, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { DropdownList } from "../../Forms";

import { wrapDispatch } from "../../Multireducer";
import {
  ColumnItem,
  ValueItem } from "./HiddenColumnsDropdownItem";


import {
  setTableViewColumnHidden,
  setTableViewAllColumnsHidden } from "../actions/libraryActions";


import { useOnClickOutsideElement } from "../../utils/useOnClickOutsideElementHook";






const mapStateToProps = (state) => ({
  columns: state.library.ui.get('tableViewColumns')
});
const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  { setTableViewColumnHidden, setTableViewAllColumnsHidden },
  wrapDispatch(dispatch, 'library')
);
const connector = connect(mapStateToProps, mapDispatchToProps);

const processColumns = (
columnsMap) =>




{
  const columns = columnsMap.toJS().slice(1);
  const hiddenColumns = columns.filter((c) => c.hidden);
  const shownColumns = columns.filter((c) => !c.hidden);
  const selectAllColumn = {
    label: 'Show all',
    selectAll: true,
    indeterminate: hiddenColumns.length !== 0 && shownColumns.length !== 0,
    hidden: shownColumns.length === 0,
    type: 'text'
  };
  const sortedColumns = [selectAllColumn].concat(
    shownColumns.concat(hiddenColumns).map((c) => _objectSpread(_objectSpread({}, c), {}, { selectAll: false }))
  );
  return { sortedColumns, hiddenColumns };
};

export const HideColumnsComponent = ({
  setTableViewAllColumnsHidden: setAllColumnsHidden,
  setTableViewColumnHidden: setColumnHidden,
  columns: columnsMap
}) => {
  const [open, setOpen] = useState(false);
  const [clickedOutside, setClickedOutside] = useState(false);

  const { sortedColumns, hiddenColumns } = processColumns(columnsMap);
  const dropdownContainerRef = useRef(null);
  const dropdownRef = useRef(null);

  const onClickOutside = useCallback((event) => {
    const target = event.target;
    if (
    target.className !== 'columns-hint' && (
    !target.parentElement || target.parentElement.className !== 'columns-hint'))
    {var _dropdownRef$current;
      setClickedOutside(true);
      (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.props.onToggle(null);
    }
  }, []);

  const handleClick = () => {
    if (open) {
      setOpen(false);
    }
  };

  useOnClickOutsideElement(dropdownContainerRef, onClickOutside);

  const onSelect = (item) =>
  item.selectAll ?
  setAllColumnsHidden(item.indeterminate ? false : !item.hidden) :
  setColumnHidden(item.name, !item.hidden);

  return (/*#__PURE__*/
    React.createElement("div", { className: "hidden-columns-dropdown", ref: dropdownContainerRef }, /*#__PURE__*/
    React.createElement(DropdownList, {
      ref: dropdownRef,
      open: open,
      data: sortedColumns,
      filter: (item, searchTerm) =>
      item.label.toLowerCase().includes(searchTerm.toLowerCase()),

      itemComponent: ColumnItem,
      valueComponent: ValueItem(hiddenColumns, open, handleClick),
      onSelect: (selected) => {
        onSelect(selected);
      },
      onToggle: (value) => {
        if (value === null || clickedOutside) {var _dropdownRef$current2;
          setOpen(false);
          setClickedOutside(false);
          (_dropdownRef$current2 = dropdownRef.current) === null || _dropdownRef$current2 === void 0 ? void 0 : _dropdownRef$current2.forceUpdate();
          return;
        }
        if (!open) {
          setOpen(true);
        }
      } }
    )
    ));

};
export const HiddenColumnsDropdown = connector(HideColumnsComponent);